import React from 'react';
import { ExternalLink } from 'lucide-react';
import { isSafeLinkHref } from '../utils/leadOutputSafety';

interface SourceLinkProps {
  label: string;
  value: string;
}

/**
 * A lead attribution URL. React does not block javascript: hrefs, and these values
 * come from a public form, so anything but http(s) or a site path renders as text.
 */
const SourceLink: React.FC<SourceLinkProps> = ({ label, value }) => (
  <div className="space-y-1">
    <p className="text-sm text-slate-400">{label}</p>
    {isSafeLinkHref(value) ? (
      <a
        href={value}
        target="_blank"
        rel="noopener noreferrer"
        className="text-amber-400 hover:text-amber-300 text-sm break-all flex items-center gap-1"
      >
        {value}
        <ExternalLink className="w-3 h-3 flex-shrink-0" />
      </a>
    ) : (
      <p className="text-slate-200 text-sm break-all">{String(value)}</p>
    )}
  </div>
);

export default SourceLink;
